import { render, staticRenderFns } from "./UserGraderTidakAktif.vue?vue&type=template&id=489a2ed6&"
import script from "./UserGraderTidakAktif.vue?vue&type=script&lang=js&"
export * from "./UserGraderTidakAktif.vue?vue&type=script&lang=js&"
import style0 from "./UserGraderTidakAktif.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports